// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","279":"component---src-pages-index-jsx"}[chunkId] + "-" + {"125":"35c5fc98db5ad8aaabbb","279":"753a0a96655e0015c2b7"}[chunkId] + ".js";
};